import React from "react";
import styled from 'styled-components';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import Banner from '@atlaskit/banner';

const Page = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 320px;
    padding: 16px 20px;
    box-sizing: border-box;
    gap: 16px;
`;

const BannerWrap = styled.div`
    width: 100%;
    max-width: 980px;
`;

const ActionCard = styled.div`
    width: 100%;
    max-width: 980px;
    background: #ffffff;
    border: 1px solid #dfe1e6;
    border-radius: 8px;
    padding: 16px;
    box-sizing: border-box;
    box-shadow: 0 1px 2px rgba(9, 30, 66, 0.08);
`;

const Title = styled.div`
    font-weight: 700;
    margin-bottom: 8px;
`;

const Text = styled.div`
    color: #44546f;
    line-height: 1.45;
    margin-bottom: 14px;
`;

const ButtonRow = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

const PrimaryButton = styled.button`
    border: 1px solid #0c66e4;
    background: #0c66e4;
    color: #ffffff;
    border-radius: 4px;
    padding: 8px 12px;
    font-weight: 600;
    cursor: pointer;
`;

const SecondaryButton = styled.button`
    border: 1px solid #dfe1e6;
    background: #ffffff;
    color: #172b4d;
    border-radius: 4px;
    padding: 8px 12px;
    font-weight: 600;
    cursor: pointer;
`;

export const NoEvents = ({ processLabel = 'Process', onBack, onRetry }) => {
    return (
        <Page>
            <BannerWrap>
                <Banner
                    appearance="error"
                    icon={<ErrorIcon label="" secondaryColor="inherit" />}
                >
                    No events were found for the activity type saved against this {processLabel} Model.
                </Banner>
            </BannerWrap>

            <ActionCard>
                <Title>This model cannot be opened because the extracted event log is empty.</Title>
                <Text>
                    Return to Models and edit the Activity Type, source table, date range, or filters.
                    You do not need to reload the whole application.
                </Text>
                <ButtonRow>
                    {onBack && (
                        <PrimaryButton type="button" onClick={onBack}>
                            Back to Models
                        </PrimaryButton>
                    )}
                    {onRetry && (
                        <SecondaryButton type="button" onClick={onRetry}>
                            Try Refresh Again
                        </SecondaryButton>
                    )}
                </ButtonRow>
            </ActionCard>
        </Page>
    );
};
